import React from 'react';
import { Robot } from '@cimpress/react-components';

const RobotDemo = () => (
  <div className="row">
    <div className="col-md-12" style={{ display: 'flex' }}>
      <Robot status="warning" />
      <Robot status="danger" />
      <Robot status="success" alternate />
      <Robot status="info" />
    </div>
  </div>
);

export default RobotDemo;
